export default __webpack_public_path__ + "static/subset-Inter-Medium-376a625c4fd8263399b5312654753cb4.woff";